/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, September 2020
 */

import React from 'react';
import {
  Paragraph,
  styled,
  Theme,
  useTheme,
} from '@staffino/primitive-controls';

const RadioInput = styled.input({
  height: 0,
  width: 0,
  opacity: 0,
  position: 'absolute',
  left: '-999rem',
});

type StyledPanelProps = {
  colorStyle?: string;
  hoverBorderColor?: string;
  theme?: Theme;
};

const StyledPanel = styled(Paragraph)<StyledPanelProps>((props) => ({
  paddingLeft: '2.1875rem',
  fontSize: '1rem',
  minHeight: '1.5625rem',
  lineHeight: '1.5625rem',

  '&::before': {
    content: "''",
    position: 'absolute' as const,
    width: 0,
    height: 0,
    top: '0.8125rem',
    left: '0.8125rem',
    borderRadius: '50%',
    backgroundColor: props.colorStyle,
    transition: 'all 200ms cubic-bezier(0.175, 0.885, 0.320, 1.275)',
  },

  'input:checked + &::before': {
    top: 0,
    left: 0,
    width: '1.625rem',
    height: '1.625rem',
  },

  'input:checked ~ &, &:hover, label:hover ~ &': {
    cursor: 'pointer',
  },

  'input:hover + &::after': {
    borderColor: props.hoverBorderColor,
    cursor: 'pointer',
  },

  '&::after': {
    content: "''",
    position: 'absolute' as const,
    width: '1.375rem',
    height: '1.375rem',
    top: 0,
    left: 0,
    border: `2px solid ${props.theme.colors.separator}`,
    borderRadius: '50%',
  },
  'input:checked + &::after': {
    background:
      'url("https://cdn-static.staffino.com/images/web/icon-multichoice-radio.svg")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '1.125rem',
    width: '1.375rem',
    height: '1.375rem',
    borderColor: props.colorStyle,
    textAlign: 'center' as const,
  },
}));
StyledPanel.defaultProps = {
  borderColor: 'separator',
  hoverBorderColor: '#a3b2bf',
};
export default function ChoiceRadioButton({
  innerRef,
  name,
  score,
  colorStyle = undefined,
  onChange = undefined,
  children = undefined,
  ...rest
}) {
  const defaultColorStyle = useTheme().colors.primaryBackground;
  const effectiveColorStyle = colorStyle || defaultColorStyle;
  return (
    <>
      <RadioInput
        ref={innerRef}
        type="radio"
        name={name}
        defaultValue={score}
        id={`${name}.${score}`}
        onChange={() => onChange?.(score)}
        {...rest}
      />
      <StyledPanel display="flex" colorStyle={effectiveColorStyle}>
        {children}
      </StyledPanel>
    </>
  );
}
